<template>
    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0 text-center" v-if="!is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0 text-center" v-else-if="!tournament">
        <p>No detail data found.</p>
         <!--      footer text-->
         <div class="note-text text-center py-10">
            <p>
                Watch (Legends League Cricket 2022/23 Matches) on Planet Cricket and Stay Updated with the Fastest Live Scores, Match Updates, Fixtures and the Schedules of All the Upcoming Matches from the Legends (League Cricket 2022/23 Matches).
            </p>
        </div>
    </div>
    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0" v-else>
        <div class="tab-content main-tabs-content">
            <div class="tab-pane fade show active" id="leagues-tab" role="tabpanel">
                <header class="info-sub-head">
                    <!-- <div class="image-box">
                            <img :src="cover" :alt="tournament.name" />
                    </div> -->
                    <div class="info-body">
                        <div class="info-body-left">
                         <h1>{{ tournament.name }} {{tournament.season}} {{this.$route.path.split('/')[3][0].toUpperCase() + this.$route.path.split('/')[3].slice(1).toLowerCase()}}</h1>
                        </div>
                        <select v-model="tournament.slug" @change="onChange()">
                            <option  v-for="year in years" :key="year.season" :value="year.slug">
                                {{year.season}}
                            </option>
                        </select>
                    </div>
                </header>
                <div class="nav-tabs-wrap">
                    <ul class="nav nav-tabs" role="tablist">
                        <li><router-link :to="{name: 'tournamentDetail.Matches'}" :class="{'active' : $route.name=='tournamentDetail.Matches'}">Matches</router-link></li>
                        <li><router-link :to="{name: 'tournamentDetail.Standings'}" :class="{'active' : $route.name=='tournamentDetail.Standings'}">Standings</router-link></li>
                        <li><router-link :to="{name: 'tournamentDetail.Teams'}" :class="{'active' : $route.name=='tournamentDetail.Teams'}">Teams</router-link></li>
                        <li><router-link :to="{name: 'tournamentDetail.Stats'}" :class="{'active' : $route.name=='tournamentDetail.Stats'}">Stats</router-link></li>
                    </ul>
                    <div class="dropdown sort-dropdown" v-if="$route.name == 'tournamentDetail.Matches'">
                        <a class="dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" href="javascript:;"
                           >Sort by <i class="ico-down-arrow"></i
                            ></a>
                        <div class="dropdown-menu">
                            <button type="button" class="dropdown-item" :class="{ all: sortBy == 'Live' }" @click="sortMatchesBy('Live')">
                                Live
                            </button>
                            <button type="button" class="dropdown-item" :class="{ all: sortBy == 'Stumps' }" @click="sortMatchesBy('Stumps')">
                                Stumps
                            </button>
                            <button type="button" class="dropdown-item" :class="{ all: sortBy == 'Cancelled' }" @click="sortMatchesBy('Cancelled')">
                                Cancelled
                            </button>
                            <button type="button" class="dropdown-item" :class="{ all: sortBy == 'Finished' }" @click="sortMatchesBy('Finished')">
                                Finished
                            </button>
                            <button type="button" class="dropdown-item" :class="{ all: sortBy == '' }" @click="sortMatchesBy('')">All Moments</button>
                        </div>
                    </div>
                </div>
                <div class="tab-content">
                    <router-view />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'tournamentDetail',

        data() {
            return {
                sortBy: '',
                tournament: null,
                cover: '',
                years: [],
            }
        },
        watch: {
            '$route.params.tournament'() {
                if(isBrowser)
                    this.getInfo()
            }
        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.getInfo()
            }
        },
        mounted() {
            this.getInfo()
        },
        methods: {
            getInfo() {
                return this.$axios
                        .get(this.$TOURNAMENT_DETAIL_API.replace(':tournament', this.$route.params.tournament))
                        .then(response => {
                            this.is_data_ready = true
                            this.cover = response.data.result.cover
                            this.tournament = response.data.result.tournament
                            this.years = response.data.result.seasons || []
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            },

            sortMatchesBy(sort) {
                this.sortBy = sort
                window.Components['tournamentMatches'].getMatches(sort)
            },
            onChange()
            {
                this.$router.push({name: 'tournamentDetail.Matches', params: {tournament: this.tournament.slug}})
            }

        }
    }
</script>

